import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogTitle,
  type WithStyles,
  withStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React, { type ComponentProps } from "react";

export type LogoutModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
} & Omit<ComponentProps<typeof Dialog>, "open" | "onClose"> &
  WithStyles<typeof styles>;

const LogoutModal = ({
  classes,
  isOpen,
  onClose,
  onLogout,
  ...rest
}: LogoutModalProps) => {
  const { t } = useTranslations();

  const handleCloseModal = () => {
    onClose();
  };

  const handleLogout = () => {
    handleCloseModal();
    onLogout();
  };

  return (
    <Dialog
      className={classes.dialog}
      open={isOpen}
      onClose={handleCloseModal}
      fullWidth={false}
      data-testid="logout-modal"
      {...rest}
    >
      <DialogTitle className={classes.title} data-testid="logout-modal-title">
        {t("login:are-you-sure-logout")}
      </DialogTitle>
      <DialogActions>
        <Button
          onClick={handleCloseModal}
          color="primary"
          data-testid="cancel-logout-button"
        >
          {t("common:actions.cancel")}
        </Button>
        <Button
          onClick={handleLogout}
          color="primary"
          autoFocus
          data-testid="logout-button"
        >
          {t("common:actions.exit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = () =>
  createStyles({
    dialog: {
      maxWidth: "450px",
      margin: "auto",
    },
    title: {
      fontWeight: "bold",
    },
  });

export default withStyles(styles)(LogoutModal);
